import React from 'react';
import { mockData } from '../utils/mock';

export const ClosingSection = () => {
  return (
    <section className="relative py-24 bg-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          {mockData.closing.lines.map((line, index) => (
            <p
              key={index}
              className={`text-2xl sm:text-3xl leading-relaxed ${
                index === 2
                  ? 'text-orange-500 font-bold text-3xl sm:text-4xl mt-12'
                  : index === 3
                  ? 'text-white font-bold text-3xl sm:text-4xl'
                  : 'text-white/80'
              }`}
            >
              {line}
            </p>
          ))}

          <div className="pt-12">
            <div className="inline-block">
              <p className="text-3xl sm:text-4xl font-bold text-white mb-2">
                Familias 360
              </p>
              <p className="text-lg text-orange-500 font-semibold">
                by Agente 360
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
